import { render } from "./App.vue?vue&type=template&id=02f617db"
const script = {}

import "./App.vue?vue&type=style&index=0&id=02f617db&lang=css"
script.render = render

export default script